import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Kraken3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KRAKEN3;
}

export default Kraken3PoiTileEntity;
